import React, { Component } from "react";
import { Link } from "react-router-dom";
import styles from "../FormSubmissionReplies/FormSubmissionReplies.module.scss";
import { Input3, Button2, ThankYouSection, ErrorSection, Checkbox, BackButton } from "../../components";
import {
  HEARD_FROM,
  MEMBER_ORGANIZATIONS,
  STAGES,
  SWITCH_DISTRIBUTORS,
  initialBoxValues,
} from "./constants";
import { EMAIL_REGEX, BEATBREAD_PRIVACY_POLICY } from "../../constants/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import * as Yup from "yup";
import { ReactComponent as Arrows } from "../../assets/SVGs/double-chevron-right.svg";
import { ARTIST_SEARCH_ESTIMATES, HOME, TERM_OF_USE } from "../../routes/constants";
import { Form, Formik } from "formik";
import axios from "axios";

class LabelWidgetForm extends Component {
  constructor() {
    super();
    this.state = {
      updatedFormData: {
        name: "",
        email: "",
        label: "",
        website: "",
        switch: "",
        heard_about_beatbread: "",
        member_of_gif: "",
        checked: false,
        turnover: "",
      },
      boxes: initialBoxValues,
      showAlert: false,
      alertText: "",
      stage: STAGES.INITIAL,
      loader: false,
    };
  }

  resetState = (additionalStates = {}) => {
    this.setState({
      updatedFormData: {
        name: "",
        email: "",
        label: "",
        website: "",
        switch: "",
        heard_about_beatbread: "",
        member_of_gif: "",
        checked: false,
        turnover: "",
      },
      boxes: initialBoxValues,
      showAlert: false,
      alertText: "",
      ...additionalStates,
    });
  };

  changeComponentErr = (alertText) => {
    return <ErrorSection onClick={this.renderInitial} subtitle={alertText} />;
  };

  changeComponentSuc = () => {
    if (this.props.isGif) {
      return <ThankYouSection hideActions={true} subtitle={
        <div className={styles.thankYou}>
          <span className={styles.thankYouText}>We are reviewing the information that you provided. We'll be in touch within the next business day.</span>
          <Button2 className={styles.button2} full lg to={HOME}>
              <p>Return to Home</p>
            <Arrows />
          </Button2>
        </div>
      } />;
    } else {
      return <ThankYouSection />;
    }
  };

  emailValidation = () => EMAIL_REGEX;

  handleSubmit = async (values) => {
    this.setState({ loader: true });
    console.log("This is running");
    const params = new URLSearchParams(window.location.search);
    const hubspotLabel = params.get("label_id");
    const payload = {
      name: values.name,
      email: values.email,
      label: values.label,
      website: values.website,
      switch: values.switch,
      heard_about_beatbread: values.heard_about_beatbread,
      member_of_gif: values.member_of_gif,
      boxes: values.turnover,
      checked: values.checked,
      ...(hubspotLabel ? { label_form_source: hubspotLabel } : {}),
    };
    this.setState({ loader: true });
    axios
      .post(
        `${process.env.REACT_APP_HUBSPOT_API_URL}/hubspot/record_label_contact/`,
        payload
      )
      .then((res) => {
        console.log("Success:", res ? res : "No response");
        this.setState({ loader: false });
        this.setState({ stage: "success" });
      })
      .catch((err) => {
        console.error("Error:", err);
        this.setState({ loader: false });
          this.setState({ alertText: err.message });
          this.setState({ stage: "error" });
      })
      .finally(() => {
        this.resetState();
      });
  };

  renderWidgetForm = () => (
    <Formik
      initialValues={this.state.updatedFormData}
      validationSchema={this.formikValidation}
      onSubmit={this.handleSubmit}
    >
      <Form className={styles.widgetBoxForm}>
        <div className={styles.heading}>
          <p className={styles.ogSubtitle}>
            Interested in accessing revenue with beatBread?
          </p>
          <h2 className={styles.ogTitle}>
            Please share a few details and we'll be in touch.
          </h2>
        </div>
        <div className={styles.form}>
          <Input3
            label="Name"
            name="name"
            autoComplete="name"
            placeholder="Ex. John Doe"
            disabled={this.state.loader}
          />
          <Input3
            label="Email Address"
            name="email"
            type="email"
            autoComplete="email"
            placeholder="johndoe@email.com"
            disabled={this.state.loader}
          />
          <Input3
            label="Label Name"
            name="label"
            autoComplete="organization"
            placeholder="beatBread"
            disabled={this.state.loader}
          />
          <Input3
            label="Website"
            name="website"
            autoComplete="url"
            placeholder="https://www.beatbread.com"
            disabled={this.state.loader}
          />
          <Input3 
            label="Can this label switch distributors? *"
            name="switch"
            input="dropdown"
            options={SWITCH_DISTRIBUTORS}
            disabled={this.state.loader}
            caption={
              <span>
                * Switching distributors is <u>not</u> required to receive
                funding. Labels that are able and willing to switch distributors
                may receive more choices and better terms.
              </span>
            }
          />
          <Input3
            input="boxes"
            title="Annual Turnover Range"
            name="turnover"
            options={this.state.boxes}
            value={this.state.turnover}
            disabled={this.state.loader}
            sm
          />
          <Input3 
            label="Where did you hear about beatBread?"
            name="heard_about_beatbread"
            input="dropdown"
            options={HEARD_FROM}
            disabled={this.state.loader}
          />
          <Input3 
            label="Are you a member of any of these organizations?"
            name="member_of_gif"
            input="dropdown"
            options={MEMBER_ORGANIZATIONS}
            disabled={this.state.loader}
          />
        </div>
        <div className={styles.tooSmall}>
          If your annual turnover is less than $25k,
          <br />
          <Link to={ARTIST_SEARCH_ESTIMATES} className={styles.applyLink}>
            Apply for funding on your top artists individually.
          </Link>
        </div>
        <div className={styles.checkboxClass}>
          <Checkbox input="checkbox" name="checked"> 
            <div className={styles.checkLabel}>
              I agree to beatBread’s{" "}
              <a href={TERM_OF_USE} target="_blank" rel="noreferrer">
                Terms of Service
              </a>{" "}
              and acknowledge beatBread’s{" "}
              <a href={BEATBREAD_PRIVACY_POLICY} target="_blank" rel="noreferrer">
                Privacy Notice
              </a>
              . I consent to receive beatBread messages via SMS. Standard call,
              message, or data rates may apply.
            </div>
          </Checkbox>
        </div>
        <Button2
          full
          className={styles.submit}
          type="submit"
          disabled={this.state.loader}
        >
          {this.state.loader ? (
            <FontAwesomeIcon icon={faCircleNotch} className="spin" />
          ):(<><p>SUBMIT</p> <Arrows /></>)}
        </Button2>
      </Form>
    </Formik>
  );

  renderInitial = () =>
    this.setState({
      stage: STAGES.INITIAL,
    });

  formikValidation = Yup.object().shape({
    name: Yup.string().label("Name").required(),
    email: Yup.string()
      .label("Email")
      .required()
      .matches(EMAIL_REGEX, "Please enter valid email"),
    label: Yup.string().label("Label").required(),
    website: Yup.string()
      .label("Website")
      .required(),
    switch: Yup.string()
      .label("Switch Distributors")
      .required("Please let us know if you can switch distributors"),
    turnover: Yup.string()
      .label("turnover")
      .required("Annual Turnover Range is Required"),
    heard_about_beatbread: Yup.string()
      .label("Hear From")
      .required("Please let us know where you heard about beatBread"),
    member_of_gif: Yup.string()
      .label("Member of GIF")
      .required("Please let us know if you are a member of a GIF organization"),
    checked: Yup.bool().required().oneOf(
      [true],
      "Please agree to the Privacy Policy before proceeding."
    ),
  });

  handleBackNavigation = () => {
    if (this.state.stage === STAGES.INITIAL) {
      return (<BackButton />);
    } else {
      return (<BackButton onClick={() => this.setState({stage: STAGES.INITIAL})} />);
    }
  }

  setStage = () => {
    switch (this.state.stage) {
      case STAGES.INITIAL:
        return this.renderWidgetForm();
      case STAGES.SUCCESS:
        return this.changeComponentSuc();
      case STAGES.ERROR:
        return this.changeComponentErr(this.state.alertText);
      default:
        return this.renderWidgetForm();
    }
  }

  render() {
    return (
      <div className={`${styles.DealCompForm} ${this.props.className}`}>
        {this.setStage()}
        {this.handleBackNavigation()}
      </div>  
    );
  }
}

export default LabelWidgetForm;
